import { render, staticRenderFns } from "./BaseRadioGroup.vue?vue&type=template&id=6a83ee78&"
import script from "./BaseRadioGroup.vue?vue&type=script&lang=js&"
export * from "./BaseRadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a83ee78')) {
      api.createRecord('6a83ee78', component.options)
    } else {
      api.reload('6a83ee78', component.options)
    }
    module.hot.accept("./BaseRadioGroup.vue?vue&type=template&id=6a83ee78&", function () {
      api.rerender('6a83ee78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseRadioGroup.vue"
export default component.exports